

export const wanSteps = {
    title: '如何用 3 步生成含音訊的影片',
    sub: '使用 Wan 2.5 生成含同步音訊的專業影片。無需音訊剪輯技能 — 對白、音樂與音效會隨影片自動生成。',
    items: [
      { num: '1', title: '步驟 1：選擇文字或圖片輸入', text: '文字轉影片：描述你的場景、運鏡、動作與音訊需求。圖片轉影片：上傳參考圖片並描述期望運動。Wan 2.5 會生成匹配的音訊，包括對白、音樂與環境聲。' },
      { num: '2', title: '步驟 2：設定時長、解析度與比例', text: '時長：5 秒（快速內容）或 10 秒（更豐富敘事）。解析度：720p（速度較快）或 1080p（最高品質）。比例：16:9 橫向、9:16 直向或 1:1 方形。可選：使用反向提示排除不需要元素。' },
      { num: '3', title: '步驟 3：生成並下載（原生音訊）', text: '點擊生成，Wan 2.5 於數分鐘內產出含同步音訊的影片。預覽完整影片含對白唇形與背景音樂。下載即可用於 YouTube、TikTok、Instagram 或商業專案。' }
    ],
  };
